import type { FilterItem, MeasureFilterData } from '@/types';
import {
  ENERGY_AND_WATER_DETAIL_ROUTE_NAME,
  ENERGY_DETAIL_ROUTE_NAME,
  WATER_DETAIL_ROUTE_NAME
} from '../routes';

export const DEFAULT_MEASURES_FILTERS: MeasureFilterData = {
  category: new Array<string>(),
  etpType: new Array<string>(),
  expenditureInvestement: new Array<string>(),
  impact: new Array<string>(),
  parameter: new Array<string>(),
  type: new Array<string>()
};

export const MEASURE_ETPTYPE_OPTIONS_EN: FilterItem[] = [
  {
    index: 'etp-type-1',
    value: 'ETP Type 1',
    description: {
      text: 'Bar screen + Collection tank + Coagulation & Flocculation + Sedimentation tank'
    }
  },
  {
    index: 'etp-type-2',
    value: 'ETP Type 2',
    description: {
      text: 'Bar screen + Collection tank + Coagulation & Flocculation + Sedimentation tank+ Pressure Sand Filter + Acivated Carbon Filter'
    }
  },
  {
    index: 'etp-type-3',
    value: 'ETP Type 3',
    description: {
      text: 'Bar screen + Collection tank + Coagulation & Flocculation + Sedimentation tank+ Aerobic Reactor + Secondary Sedimentation'
    }
  }
];

export const MEASURE_IMPACT_OPTIONS_EN: FilterItem[] = [
  {
    index: 'low',
    value: 'Low'
  },
  {
    index: 'medium',
    value: 'Medium'
  },
  {
    index: 'high',
    value: 'High'
  },
  {
    index: 'very-high',
    value: 'Very High'
  }
];

export const MEASURE_INVESTMENT_OPTIONS_EN: FilterItem[] = [
  {
    index: '$',
    value: '$'
  },
  {
    index: '$$',
    value: '$$'
  },
  {
    index: '$$$',
    value: '$$$'
  },
  {
    index: '$$$$',
    value: '$$$$'
  }
];

export const MEASURE_PARAMETER_OPTIONS_EN: FilterItem[] = [
  {
    index: 'ammonium-n',
    value: 'Amomonium-N'
  },
  {
    index: 'antimony',
    value: 'Antimony'
  },
  {
    index: 'aox',
    value: 'AOX',
    description: {
      title: 'Halogenated Organic Compounds',
      text: 'Organic halogen compounds are derivatives of organic compounds in which one or more hydrogen atoms have been replaced by an equal number of halogen atoms (F, Cl, Br, or I).'
    }
  },
  {
    index: 'arsenic',
    value: 'Arsenic'
  },
  {
    index: 'bod5',
    value: 'BOD5',
    description: {
      title: 'Biochemical Oxygen Demand',
      text: 'BOD5 measures the mass of molecular oxygen consumed by micro-organisms in five days in one litre of water at 20°C.'
    }
  },
  {
    index: 'cadmium',
    value: 'Cadmium'
  },
  {
    index: 'chromium-(vi)',
    value: 'Chromium (VI)'
  },
  {
    index: 'chromium,-total',
    value: 'Chromium, total'
  },
  {
    index: 'cobalt',
    value: 'Cobalt'
  },
  {
    index: 'cod',
    value: 'COD',
    description: {
      title: 'Chemical Oxygen Demand',
      text: 'Chemical Oxygen Demand (COD) is the amount of dissolved oxygen that must be present in water to oxidize organic matter. A COD test can be used to easily quantify the amount of organics in water.'
    }
  },
  {
    index: 'coliform-[bacteria/100-ml]',
    value: 'Coliform [bacteria/100 ml]'
  },
  {
    index: 'colour-[m-1]-(436-nm;-525-nm;620-nm)',
    value: 'Colour [m-1] (436 nm; 525 nm;620 nm)'
  },
  {
    index: 'conductivity',
    value: 'Conductivity'
  },
  {
    index: 'copper',
    value: 'Copper'
  },
  {
    index: 'cyanide---total',
    value: 'Cyanide - total'
  },
  {
    index: 'lead',
    value: 'Lead'
  },
  {
    index: 'mercury',
    value: 'Mercury'
  },
  {
    index: 'nickel',
    value: 'Nickel'
  },
  {
    index: 'oil-and-grease',
    value: 'Oil and Grease'
  },
  {
    index: 'persistent-foam',
    value: 'Persistent Foam'
  },
  {
    index: 'ph',
    value: 'Ph'
  },
  {
    index: 'phenol',
    value: 'Phenol'
  },
  {
    index: 'silver',
    value: 'Silver'
  },
  {
    index: 'sulfide',
    value: 'Sulfide'
  },
  {
    index: 'sulfite',
    value: 'Sulfite'
  },
  {
    index: 'temperature',
    value: 'Temperature'
  },
  {
    index: 'total-n',
    value: 'Total N'
  },
  {
    index: 'total-p',
    value: 'Total P'
  },
  {
    index: 'tss',
    value: 'TSS',
    description: {
      title: 'Total Solids Suspended',
      text: 'Total Suspended Solids (TSS) is the portion of fine particulate matter that remains in suspension in water.'
    }
  },
  {
    index: 'zinc',
    value: 'Zinc'
  }
];

export const MEASURE_TYPE_OPTIONS_EN: FilterItem[] = [
  {
    index: ENERGY_DETAIL_ROUTE_NAME,
    value: 'Energy'
  },
  {
    index: WATER_DETAIL_ROUTE_NAME,
    value: 'Water'
  },
  {
    index: ENERGY_AND_WATER_DETAIL_ROUTE_NAME,
    value: 'Energy and Water'
  }
];

export const MEASURE_ORDER_OPTIONS_EN: FilterItem[] = [
  {
    index: 'estimatedInvestmentExpenditureSumup',
    value: 'Cost'
  },
  {
    index: 'impactEnergy',
    value: 'Energy Impact'
  },
  {
    index: 'impactWater',
    value: 'Water Impact'
  }
];
